<template>
    <parent-page-menu-item v-if="page.children && page.children.length != 0"
                           :page="page"
                           :parentSlug="parentSlug"
                           :level="level"
                           :padding="padding"
                           :actual-uri="actualUri"/>
    <li :class="itemClass" v-else>
        <router-link :to="uri" :style="padding">
            <span class="menu-icon"></span>{{page.title}}
        </router-link>
    </li>
</template>

<script>
  import ParentPageMenuItem from './ParentPageMenuItem.vue';

  export default {
    name: 'PageMenuItem',
    props: ['page', 'parentSlug', 'actualUri', 'level'],
    components: {
      ParentPageMenuItem
    },
    computed: {
      itemClass() {
        return 'list-group-item ' + (this.actualUri === this.uri ? 'active' : '');
      },
      uri() {
        return `/page/${this.parentSlug}/${this.page.slug}`;
      },
      padding() {
        return 'padding-left: ' + (parseInt(this.level) * 15) + 'px;';
      }
    }
  };
</script>

<style scoped>

</style>
